export const UTM_TRACKING_KEY: string = 'alle-utm-json';
export const PROVIDER_ATTRIBUTION_TRACKING_KEY: string =
  'alle-provider-attribution-json';
